const permissionCheck = (user:any,permissionsToCheck:string[]): boolean => {
    return user?.permissions?.some((permission: any) =>permissionsToCheck.includes(permission)) || false;
};

export default permissionCheck;
